import { writable } from 'svelte/store';

export type ToastType = 'success' | 'error' | 'info';

export interface ToastMessage {
  id: number;
  message: string;
  type: ToastType;
}

export const toasts = writable<ToastMessage[]>([]);

let idCounter = 0;

export function addToast(message: string, type: ToastType = 'info', duration = 4000) {
  const id = ++idCounter;
  const toast: ToastMessage = { id, message, type };
  toasts.update(all => [toast, ...all]);

  setTimeout(() => {
    removeToast(id);
  }, duration);
}

export function removeToast(id: number) {
  toasts.update(all => all.filter(t => t.id !== id));
}
